import { render, staticRenderFns } from "./FaceDirection.vue?vue&type=template&id=15b07a90&scoped=true&"
import script from "./FaceDirection.vue?vue&type=script&lang=ts&"
export * from "./FaceDirection.vue?vue&type=script&lang=ts&"
import style0 from "./FaceDirection.vue?vue&type=style&index=0&id=15b07a90&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b07a90",
  null
  
)

export default component.exports